// // import styled, { css } from 'styled-components';
// // import { darken } from 'polished';

// // export const Container = styled.div`
// //   display: flex;
// //   flex-direction: column;

// //   /** fixa largura total da tela */
// //   height: calc(100vh - 100px);
// // `;

// // Container.Header = styled.div`
// //   background: #fff;
// //   box-shadow: 0px 3px 6px #0000000d;
// //   border-radius: 10px;
// //   /* height: 100%; */
// //   min-height: 58px;

// //   display: flex;
// //   align-items: center;
// // `;

// // Container.Header.BtnBack = styled.button`
// //   background: none;
// //   border-radius: 10px;
// //   border: none;
// //   margin-left: 10px;
// //   height: 50px;
// //   width: 50px;
// //   color: #2c405a;
// //   transition: all 1s;

// //   :hover {
// //     /* background: ${darken(0.05, '#fff')}; */
// //     background: ${darken(0.05, 'rgba(44, 64, 90, 0.05)')};
// //   }
// // `;

// // Container.Header.DownloadPdf = styled.a`
// //   background: none;
// //   border-radius: 10px;
// //   border: none;
// //   height: 50px;
// //   width: 50px;
// //   color: #2c405a;
// //   transition: all 1s;
// //   display: flex;
// //   justify-content: center;
// //   align-items: center;
// //   :hover {
// //     background: ${darken(0.05, 'rgba(44, 64, 90, 0.05)')};
// //   }
// // `;

// // Container.Header.BtnFavorite = styled.button`
// //   background: none;
// //   border: 0;
// //   border-radius: 5px;
// //   color: #2c405a;
// //   height: 40px;
// //   width: 40px;
// // `;

// // export const WrapperTitleInfo = styled.div`
// //   display: flex;
// //   flex-direction: row;
// //   flex: 1;
// //   padding: 0 10px;
// // `;

// // export const WrapperSubtitles = styled.div`
// //   display: flex;
// //   flex: 1;
// //   flex-direction: row;
// //   padding: 0 10px;
// // `;

// // export const WrapperTittleInfoSubtitle = styled.div`
// //   display: flex;
// //   flex: 1;
// //   flex-direction: column;
// // `;

// // Container.Header.Title = styled.h1`
// //   width: auto;
// //   font-size: 18px;
// //   color: #2c405a;
// //   position: relative;
// // `;

// // Container.Header.Subtitle = styled.span`
// //   font-size: 14px;
// //   padding-top: 2px;
// //   color: #2c405a;

// //   + span {
// //     padding-left: 5px;
// //   }
// // `;

// // Container.Header.Search = styled.div`
// //   /* padding: 2px 10px; */
// // `;

// // export const Wrapper = styled.div`
// //   flex: 1;
// //   display: flex;
// //   height: 100%;
// //   margin: 6px 0;
// // `;

// // const Menu = styled.div`
// //   display: flex;
// //   box-shadow: 0px 3px 6px #0000000d;
// //   background: #fff;
// //   border-radius: 10px;
// //   height: calc(100vh - 180px);
// //   max-width: 350px;
// //   margin-right: 20px;
// // `;

// // Menu.BtnCollapse = styled.button`
// //   background: none;
// //   border: 0;
// //   border-top-right-radius: 10px;
// //   border-bottom-right-radius: 10px;
// //   color: #a7a7a7;
// //   width: 18px;
// //   transform: background 1s;

// //   ${(props) =>
// //     props.collapse &&
// //     css`
// //       border-top-left-radius: 10px;
// //       border-bottom-left-radius: 10px;
// //     `}

// //   :hover {
// //     background: #cad5f8;
// //     color: #fff;
// //   }
// // `;

// // Menu.Content = styled.div`
// //   display: flex;
// //   flex-direction: column;
// //   width: 100%;
// //   visibility: visible;

// //   /* oculta/exibe menu lateral */
// //   ${(props) =>
// //     props.hidden &&
// //     css`
// //       width: 0;
// //       padding: 0;
// //       visibility: hidden;
// //     `}
// // `;

// // Menu.Content.Filter = styled.div`
// //   display: flex;
// //   flex-wrap: wrap;
// //   font-size: 12px;
// //   padding: 0 5px;

// //   > span {
// //     display: flex;
// //     align-items: center;
// //     border: 1px solid #cbd0d8;
// //     color: #444;
// //     height: 22px;
// //     border-radius: 5px;
// //     padding-left: 5px;
// //     margin: 2px 0;

// //     & + span {
// //       margin-left: 5px;
// //     }

// //     > button {
// //       height: 22px;
// //       width: 22px;
// //       color: #444;
// //       margin-left: 5px;
// //       background: none;
// //       border: 0;
// //       border-top-right-radius: 5px;
// //       border-bottom-right-radius: 5px;
// //       transition: background 1s;

// //       :hover {
// //         border: 1px solid #cad5f8;
// //         background: #cad5f8;
// //         color: #fff;
// //       }
// //     }
// //   }
// // `;

// // Menu.Content.TreeView = styled.div`
// //   flex: 1;
// //   overflow: auto;

// //   padding: 5px 0 5px 2px;

// //   ::-webkit-scrollbar {
// //     display: none;
// //   }
// // `;

// // Menu.Content.File = styled.div`
// //   margin-top: 20px;
// //   border-top: 1px solid #0000000d;
// //   padding: 20px 0;

// //   > h4 {
// //     font-size: 16px;
// //   }

// //   > ul {
// //     padding: 15px 0;

// //     > li {
// //       padding: 2px 0;

// //       > a {
// //         font-size: 14px;
// //         color: #2c405a;
// //         transform: color 1s;

// //         :hover {
// //           color: ${darken(0.05, '#2c405a')};
// //         }
// //       }
// //     }
// //   }
// // `;

// // export const Content = styled.div`
// //   flex: 1;
// //   flex-direction: column;
// //   /* padding-left: 20px; */
// //   height: 100%;
// //   /* max-height: inherit; */
// // `;

// // Content.ToolBar = styled.div`
// //   display: flex;
// //   min-height: 60px;
// //   padding: 0 0 10px;
// // `;

// // Content.ToolBar.Header = styled.div`
// //   flex: 1;
// //   color: #888888;
// //   font-size: 13px;

// //   > div {
// //     display: flex;
// //     align-items: center;

// //     > h5 {
// //       font-size: 14px;
// //       display: inline;
// //       padding-right: 3px;
// //     }

// //     > span {
// //       padding: 5px 0 5px 0;
// //       font-size: 14px;
// //       padding-right: 3px;
// //     }

// //     > button {
// //       margin-left: 5px;
// //       background-color: #fecaca;
// //       align-content: center;
// //       border-radius: 5px;
// //       width: 25px;
// //       height: 25px;
// //       border: none;
// //       color: #dc2626;
// //       transition: 0.5s;

// //       &:hover {
// //         transition: 0.5s;
// //         background-color: #fca5a5;
// //         color: #b91c1c;
// //       }
// //     }
// //   }

// //   > h3 {
// //     color: #2c405a;
// //     font-size: 16px;
// //     padding: 5px 0;
// //   }

// //   > a {
// //     padding: 5px 0;
// //     transform: color 1s;

// //     :hover {
// //       color: ${darken(0.05, '#888888')};
// //       /* text-decoration: underline; */
// //     }
// //   }
// // `;
// // Content.ToolBar.DrawControl = styled.div`
// //   display: flex;
// //   align-items: flex-end;

// //   > button,
// //   span {
// //     display: flex;
// //     align-items: center;
// //     justify-content: center;
// //     /* border: 0; */
// //     border-radius: 10px;
// //     /* background: rgba(44, 64, 90, 0.05); */
// //     /* color: #2c405a; */
// //     height: 32px;
// //     width: 32px;
// //     /* border: 1px solid; */
// //     background: none;
// //     border: 0;
// //     color: #2c405a;
// //     transition: background 1s;

// //     + button {
// //       margin-left: 2px;
// //     }

// //     + span {
// //       width: none;
// //       margin-left: 5px;
// //       padding: 0 8px;
// //       white-space: nowrap;
// //     }

// //     :hover {
// //       background: ${darken(0.05, 'rgba(44, 64, 90, 0.05)')};
// //     }
// //   }

// //   /** separação entre ferramentas de navegação de páginas e redimensionamneto da imagem */
// //   button:nth-of-type(2) {
// //     margin-right: 5px;
// //   }
// // `;

// // export const BtnFilter = styled.button`
// //   padding: 0 8px;
// //   height: 40px;
// //   margin: auto;
// //   background-color: #2c405a;
// //   color: #fff;
// //   border-radius: 0 5px 5px 0;
// //   border: none;
// // `;

// // export { Menu };

// import styled, { css } from 'styled-components';
// import { darken } from 'polished';

// /* ===== Identidade visual (alinhada ao login / Header) =====
//    --primary: #ff6d3c   --ink: #2c405a / #17263b   --muted: #79869e
//    --border: rgba(216, 224, 235, 0.9)

//    As métricas de altura (--app-chrome-h, --cat-titlebar-h, --cat-toolbar-h)
//    e das colunas laterais (--cat-rail-w, --cat-panel-w) estão em
//    styles/global.js, com valores reduzidos para tablets / telas de baixa
//    altura (referência: 1340 x 800).
// =========================================================== */

// export const Container = styled.div`
//   display: flex;
//   flex-direction: column;

//   /**
//    * Altura útil da tela = viewport menos o "chrome" da aplicação
//    * (header + paddings do layout + footer). Antes era um calc fixo
//    * (100vh - 100px) que estourava a tela em resoluções de 800px de altura.
//    */
//   height: calc(100vh - var(--app-chrome-h));
//   min-height: 0;
//   overflow: hidden;
// `;

// Container.Header = styled.div`
//   flex: 0 0 auto;
//   display: flex;
//   align-items: center;

//   min-height: var(--cat-titlebar-h);
//   background: #fff;
//   border: 1px solid rgba(216, 224, 235, 0.9);
//   border-radius: 12px;
//   box-shadow: 0 6px 18px rgba(23, 38, 59, 0.05);

//   /** evita que o campo de pesquisa force o crescimento horizontal */
//   overflow: visible;
// `;

// Container.Header.BtnBack = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   flex: 0 0 auto;

//   background: none;
//   border-radius: 10px;
//   border: none;
//   margin-left: 8px;
//   height: 40px;
//   width: 40px;
//   color: #2c405a;
//   transition: background 0.2s ease, color 0.2s ease;

//   :hover {
//     background: rgba(255, 109, 60, 0.12);
//     color: #ff6d3c;
//   }

//   > svg {
//     height: 24px;
//     width: 24px;
//   }
// `;

// Container.Header.DownloadPdf = styled.a`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   flex: 0 0 auto;

//   background: none;
//   border-radius: 10px;
//   border: none;
//   height: 40px;
//   width: 40px;
//   color: #2c405a;
//   transition: background 0.2s ease, color 0.2s ease;

//   :hover {
//     background: rgba(255, 109, 60, 0.12);
//     color: #ff6d3c;
//   }

//   > svg {
//     height: 24px;
//     width: 24px;
//   }
// `;

// Container.Header.BtnFavorite = styled.button`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   flex: 0 0 auto;

//   background: none;
//   border: 0;
//   border-radius: 10px;
//   color: #2c405a;
//   height: 36px;
//   width: 36px;
//   transition: background 0.2s ease, color 0.2s ease;

//   :hover {
//     background: rgba(255, 109, 60, 0.12);
//     color: #ff6d3c;
//   }
// `;

// export const WrapperTitleInfo = styled.div`
//   display: flex;
//   flex-direction: row;
//   flex: 1;
//   min-width: 0;
//   padding: 0 10px;
// `;

// export const WrapperSubtitles = styled.div`
//   display: flex;
//   flex: 1;
//   flex-direction: row;
//   min-width: 0;
//   padding: 0 10px;
// `;

// export const WrapperTittleInfoSubtitle = styled.div`
//   display: flex;
//   flex: 1;
//   flex-direction: column;
//   justify-content: center;
//   min-width: 0;
// `;

// Container.Header.Title = styled.h1`
//   position: relative;
//   width: auto;
//   font-size: 17px;
//   line-height: 1.2;
//   color: #17263b;

//   /** título longo não deve empurrar a pesquisa para fora da barra */
//   max-width: 100%;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   white-space: nowrap;

//   @media (max-width: 1440px), (max-height: 900px) {
//     font-size: 15px;
//   }
// `;

// Container.Header.Subtitle = styled.span`
//   font-size: 13px;
//   padding-top: 1px;
//   color: #79869e;
//   white-space: nowrap;

//   + span {
//     padding-left: 5px;
//   }

//   @media (max-width: 1440px), (max-height: 900px) {
//     font-size: 12px;
//   }
// `;

// Container.Header.Search = styled.div`
//   flex: 0 0 auto;
//   padding: 0 6px;
// `;

// export const Wrapper = styled.div`
//   position: relative;
//   flex: 1 1 auto;
//   display: flex;
//   align-items: stretch;

//   min-height: 0;
//   min-width: 0;
//   height: 100%;
//   margin: 6px 0 0;
// `;

// /* =====================================================================
//    COLUNAS LATERAIS (árvore de sistemas / faces do sistema)
//    ---------------------------------------------------------------------
//    Antes: dois painéis de até 350px sempre abertos, consumindo ~740px de
//    um total de 1340px e sobrando pouco espaço para o desenho e a tabela.

//    Agora: cada coluna é um TRILHO vertical estreito (--cat-rail-w) que
//    permanece sempre visível, com ícone e rótulo. Ao abrir, o painel
//    (--cat-panel-w) é sobreposto ao conteúdo (position: absolute), de modo
//    que o desenho da peça NÃO é redimensionado ao consultar a árvore.
//    ===================================================================== */
// const Menu = styled.div`
//   position: relative;
//   z-index: 20;
//   flex: 0 0 auto;
//   display: flex;

//   height: 100%;
//   width: var(--cat-rail-w);
//   margin-right: 8px;
// `;

// /** Trilho: botão de abrir/fechar, sempre visível */
// Menu.BtnCollapse = styled.button`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: flex-start;
//   gap: 10px;

//   height: 100%;
//   width: 100%;
//   padding: 10px 0;

//   background: linear-gradient(180deg, #ffffff 0%, #f7fafd 100%);
//   border: 1px solid rgba(216, 224, 235, 0.9);
//   border-radius: 12px;
//   box-shadow: 0 6px 18px rgba(23, 38, 59, 0.05);
//   color: #79869e;

//   cursor: pointer;
//   transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease,
//     box-shadow 0.2s ease;

//   /** rótulo vertical do trilho */
//   > span {
//     flex: 1;
//     display: flex;
//     align-items: center;
//     justify-content: center;

//     font-size: 11px;
//     font-weight: 800;
//     letter-spacing: 1px;
//     text-transform: uppercase;
//     white-space: nowrap;

//     writing-mode: vertical-rl;
//     transform: rotate(180deg);
//   }

//   /** chevron indicando o sentido da ação */
//   > svg {
//     flex: 0 0 auto;
//   }

//   :hover {
//     color: #ff6d3c;
//     background: #fff;
//     border-color: rgba(255, 109, 60, 0.45);
//     box-shadow: 0 10px 24px rgba(255, 109, 60, 0.14);
//   }

//   /** trilho aberto: destaque em laranja da marca */
//   ${(props) =>
//     !props.collapse &&
//     css`
//       color: #ff6d3c;
//       background: #fff;
//       border-color: rgba(255, 109, 60, 0.55);
//       box-shadow: inset 3px 0 0 #ff6d3c, 0 8px 20px rgba(255, 109, 60, 0.14);
//     `}
// `;

// /** Painel sobreposto com o conteúdo da coluna */
// Menu.Content = styled.div`
//   position: absolute;
//   top: 0;
//   left: 100%;
//   z-index: 21;

//   display: flex;
//   flex-direction: column;

//   height: 100%;
//   width: var(--cat-panel-w);
//   margin-left: 8px;
//   padding: 10px;

//   background: #fff;
//   border: 1px solid rgba(216, 224, 235, 0.9);
//   border-radius: 14px;
//   box-shadow: 0 24px 60px rgba(23, 38, 59, 0.18);

//   opacity: 1;
//   visibility: visible;
//   transform: translateX(0);
//   transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;

//   /* oculta/exibe painel lateral */
//   ${(props) =>
//     props.hidden &&
//     css`
//       opacity: 0;
//       visibility: hidden;
//       pointer-events: none;
//       transform: translateX(-10px);
//     `}
// `;

// /** Cabeçalho do painel: título + botão de fechar */
// Menu.Content.Header = styled.div`
//   flex: 0 0 auto;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   gap: 8px;

//   padding: 0 2px 8px;
//   margin-bottom: 6px;
//   border-bottom: 1px solid rgba(216, 224, 235, 0.9);

//   > strong {
//     display: flex;
//     align-items: center;
//     gap: 6px;

//     color: #17263b;
//     font-size: 13px;
//     font-weight: 800;
//     letter-spacing: 0.4px;
//     text-transform: uppercase;

//     > svg {
//       color: #ff6d3c;
//     }
//   }

//   > button {
//     display: flex;
//     align-items: center;
//     justify-content: center;

//     height: 32px;
//     width: 32px;
//     background: none;
//     border: 0;
//     border-radius: 9px;
//     color: #79869e;
//     transition: background 0.2s ease, color 0.2s ease;

//     :hover {
//       background: rgba(255, 109, 60, 0.12);
//       color: #ff6d3c;
//     }
//   }
// `;

// Menu.Content.Filter = styled.div`
//   flex: 0 0 auto;
//   display: flex;
//   flex-wrap: wrap;
//   font-size: 12px;
//   padding: 0 0 6px;

//   > span {
//     display: flex;
//     align-items: center;
//     border: 1px solid rgba(216, 224, 235, 0.9);
//     background: rgba(247, 250, 253, 0.9);
//     color: #2c405a;
//     height: 24px;
//     border-radius: 999px;
//     padding-left: 9px;
//     margin: 2px 0;

//     & + span {
//       margin-left: 5px;
//     }

//     > button {
//       display: flex;
//       align-items: center;
//       justify-content: center;

//       height: 24px;
//       width: 24px;
//       color: #79869e;
//       margin-left: 3px;
//       background: none;
//       border: 0;
//       border-radius: 999px;
//       transition: background 0.2s ease, color 0.2s ease;

//       :hover {
//         background: rgba(255, 109, 60, 0.14);
//         color: #ff6d3c;
//       }
//     }
//   }
// `;

// Menu.Content.TreeView = styled.div`
//   flex: 1 1 auto;
//   min-height: 0;
//   display: flex;
//   flex-direction: column;

//   overflow-y: auto;
//   overflow-x: hidden;
//   padding: 2px;
// `;

// Menu.Content.File = styled.div`
//   margin-top: 20px;
//   border-top: 1px solid #0000000d;
//   padding: 20px 0;

//   > h4 {
//     font-size: 16px;
//   }

//   > ul {
//     padding: 15px 0;

//     > li {
//       padding: 2px 0;

//       > a {
//         font-size: 14px;
//         color: #2c405a;
//         transform: color 1s;

//         :hover {
//           color: ${darken(0.05, '#2c405a')};
//         }
//       }
//     }
//   }
// `;

// export const Content = styled.div`
//   flex: 1 1 auto;
//   display: flex;
//   flex-direction: column;

//   /** min-height/min-width 0: permitem que o desenho e a tabela encolham */
//   min-height: 0;
//   min-width: 0;
//   height: 100%;
// `;

// Content.ToolBar = styled.div`
//   flex: 0 0 auto;
//   display: flex;
//   align-items: flex-start;
//   gap: 8px;

//   min-height: var(--cat-toolbar-h);
//   padding: 0 0 6px;
// `;

// Content.ToolBar.Header = styled.div`
//   flex: 1;
//   min-width: 0;
//   color: #79869e;
//   font-size: 12px;

//   > div {
//     display: flex;
//     align-items: center;

//     > h5 {
//       font-size: 13px;
//       display: inline;
//       padding-right: 3px;
//     }

//     > span {
//       padding: 3px 0;
//       font-size: 13px;
//       padding-right: 3px;
//     }

//     > button {
//       display: flex;
//       align-items: center;
//       justify-content: center;

//       margin-left: 5px;
//       background-color: #fecaca;
//       border-radius: 6px;
//       width: 24px;
//       height: 24px;
//       border: none;
//       color: #dc2626;
//       transition: 0.3s;

//       &:hover {
//         background-color: #fca5a5;
//         color: #b91c1c;
//       }
//     }
//   }

//   > h3 {
//     color: #17263b;
//     font-size: 15px;
//     padding: 2px 0;

//     /** título da página não deve quebrar a altura da toolbar */
//     overflow: hidden;
//     text-overflow: ellipsis;
//     white-space: nowrap;
//   }

//   > a {
//     padding: 2px 0;
//     transition: color 0.2s ease;

//     :hover {
//       color: ${darken(0.05, '#888888')};
//     }
//   }

//   @media (max-width: 1440px), (max-height: 900px) {
//     > h3 {
//       font-size: 14px;
//     }
//   }
// `;

// Content.ToolBar.DrawControl = styled.div`
//   flex: 0 0 auto;
//   display: flex;
//   align-items: center;
//   flex-wrap: nowrap;

//   padding: 2px;
//   background: #fff;
//   border: 1px solid rgba(216, 224, 235, 0.9);
//   border-radius: 12px;
//   box-shadow: 0 6px 16px rgba(23, 38, 59, 0.05);

//   > button,
//   span {
//     display: flex;
//     align-items: center;
//     justify-content: center;

//     /** 34px mantém o alvo de toque confortável em tablet */
//     height: 34px;
//     width: 34px;
//     border-radius: 9px;
//     background: none;
//     border: 0;
//     color: #2c405a;
//     transition: background 0.2s ease, color 0.2s ease;

//     + button {
//       margin-left: 2px;
//     }

//     + span {
//       width: auto;
//       min-width: 34px;
//       margin-left: 4px;
//       padding: 0 8px;
//       font-size: 13px;
//       font-weight: 700;
//       white-space: nowrap;
//     }

//     :hover {
//       background: rgba(255, 109, 60, 0.12);
//       color: #ff6d3c;
//     }

//     &:disabled {
//       opacity: 0.55;
//       cursor: default;
//     }
//   }

//   /** separação entre navegação de páginas e ferramentas da imagem */
//   button:nth-of-type(2) {
//     margin-right: 4px;
//   }
// `;

// export const BtnFilter = styled.button`
//   padding: 0 8px;
//   height: 40px;
//   margin: auto;
//   background-color: #2c405a;
//   color: #fff;
//   border-radius: 0 5px 5px 0;
//   border: none;
// `;

// export { Menu };

import styled, { css } from 'styled-components';
import { darken } from 'polished';

/* ===== Identidade visual (alinhada ao login / Header) =====
   --primary: #ff6d3c   --ink: #2c405a / #17263b   --muted: #79869e
   --border: rgba(216, 224, 235, 0.9)

   As métricas de altura (--app-chrome-h, --cat-titlebar-h, --cat-toolbar-h)
   e das colunas laterais (--cat-rail-w, --cat-panel-w) estão em
   styles/global.js, com valores reduzidos para tablets / telas de baixa
   altura (referência: 1340 x 800).
=========================================================== */

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  /**
   * Altura útil da tela = viewport menos o "chrome" da aplicação
   * (header + paddings do layout + footer). Antes era um calc fixo
   * (100vh - 100px) que estourava a tela em resoluções de 800px de altura.
   */
  height: calc(100vh - var(--app-chrome-h));
  min-height: 0;
  overflow: hidden;
`;

Container.Header = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;

  min-height: var(--cat-titlebar-h);
  background: #fff;
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(23, 38, 59, 0.05);

  /** evita que o campo de pesquisa force o crescimento horizontal */
  overflow: visible;
`;

Container.Header.BtnBack = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;

  background: none;
  border-radius: 10px;
  border: none;
  margin-left: 8px;
  height: 40px;
  width: 40px;
  color: #2c405a;
  transition: background 0.2s ease, color 0.2s ease;

  :hover {
    background: rgba(255, 109, 60, 0.12);
    color: #ff6d3c;
  }

  > svg {
    height: 24px;
    width: 24px;
  }
`;

Container.Header.DownloadPdf = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;

  background: none;
  border-radius: 10px;
  border: none;
  height: 40px;
  width: 40px;
  color: #2c405a;
  transition: background 0.2s ease, color 0.2s ease;

  :hover {
    background: rgba(255, 109, 60, 0.12);
    color: #ff6d3c;
  }

  > svg {
    height: 24px;
    width: 24px;
  }
`;

Container.Header.BtnFavorite = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;

  background: none;
  border: 0;
  border-radius: 10px;
  color: #2c405a;
  height: 36px;
  width: 36px;
  transition: background 0.2s ease, color 0.2s ease;

  :hover {
    background: rgba(255, 109, 60, 0.12);
    color: #ff6d3c;
  }
`;

export const WrapperTitleInfo = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-width: 0;
  padding: 0 10px;
`;

export const WrapperSubtitles = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  min-width: 0;
  padding: 0 10px;
`;

export const WrapperTittleInfoSubtitle = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
`;

Container.Header.Title = styled.h1`
  position: relative;
  width: auto;
  font-size: 17px;
  line-height: 1.2;
  color: #17263b;

  /** título longo não deve empurrar a pesquisa para fora da barra */
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: 1440px), (max-height: 900px) {
    font-size: 15px;
  }
`;

Container.Header.Subtitle = styled.span`
  font-size: 13px;
  padding-top: 1px;
  color: #79869e;
  white-space: nowrap;

  + span {
    padding-left: 5px;
  }

  @media (max-width: 1440px), (max-height: 900px) {
    font-size: 12px;
  }
`;

Container.Header.Search = styled.div`
  flex: 0 0 auto;
  padding: 0 6px;
`;

export const Wrapper = styled.div`
  position: relative;
  flex: 1 1 auto;
  display: flex;
  align-items: stretch;

  min-height: 0;
  min-width: 0;
  height: 100%;
  margin: 6px 0 0;
`;

/* =====================================================================
   COLUNAS LATERAIS (árvore de sistemas / faces do sistema)
   ---------------------------------------------------------------------
   Antes: dois painéis de até 350px sempre abertos, consumindo ~740px de
   um total de 1340px e sobrando pouco espaço para o desenho e a tabela.

   Agora: um único DOCK reúne os trilhos verticais estreitos
   (--cat-rail-w cada, sempre visíveis, com ícone e rótulo). Ao abrir, o
   painel (--cat-panel-w) é sobreposto ao conteúdo, de modo que o desenho
   da peça NÃO é redimensionado ao consultar a árvore.

   IMPORTANTE: os painéis são posicionados em relação ao DOCK (e não a cada
   trilho individualmente). Isso garante que:
     1. ambos abrem exatamente no mesmo lugar, à direita dos trilhos;
     2. ficam no mesmo contexto de empilhamento, sem que o painel de
        sistemas apareça atrás da coluna de faces do sistema.
   ===================================================================== */
const Menu = styled.div`
  position: relative;
  z-index: 30;
  flex: 0 0 auto;
  display: flex;
  align-items: stretch;

  height: 100%;
  margin-right: 8px;
`;

/** Trilho: botão de abrir/fechar, sempre visível */
Menu.BtnCollapse = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;

  flex: 0 0 auto;
  height: 100%;
  width: var(--cat-rail-w);
  padding: 10px 0;

  /** espaçamento entre os trilhos quando há mais de uma coluna */
  + button {
    margin-left: 8px;
  }

  background: linear-gradient(180deg, #ffffff 0%, #f7fafd 100%);
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 12px;
  box-shadow: 0 6px 18px rgba(23, 38, 59, 0.05);
  color: #79869e;

  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease,
    box-shadow 0.2s ease;

  /** rótulo vertical do trilho */
  > span {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 11px;
    font-weight: 800;
    letter-spacing: 1px;
    text-transform: uppercase;
    white-space: nowrap;

    writing-mode: vertical-rl;
    transform: rotate(180deg);
  }

  /** chevron indicando o sentido da ação */
  > svg {
    flex: 0 0 auto;
  }

  :hover {
    color: #ff6d3c;
    background: #fff;
    border-color: rgba(255, 109, 60, 0.45);
    box-shadow: 0 10px 24px rgba(255, 109, 60, 0.14);
  }

  /** trilho aberto: destaque em laranja da marca */
  ${(props) =>
    !props.collapse &&
    css`
      color: #ff6d3c;
      background: #fff;
      border-color: rgba(255, 109, 60, 0.55);
      box-shadow: inset 3px 0 0 #ff6d3c, 0 8px 20px rgba(255, 109, 60, 0.14);
    `}
`;

/**
 * Painel sobreposto com o conteúdo da coluna.
 * left: 100% refere-se ao DOCK inteiro (Menu), por isso todos os painéis
 * abrem na mesma posição, imediatamente à direita do último trilho.
 */
Menu.Content = styled.div`
  position: absolute;
  top: 0;
  left: 100%;
  z-index: 1;

  display: flex;
  flex-direction: column;

  height: 100%;
  width: var(--cat-panel-w);
  margin-left: 8px;
  padding: 10px;

  background: #fff;
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 14px;
  box-shadow: 0 24px 60px rgba(23, 38, 59, 0.18);

  opacity: 1;
  visibility: visible;
  transform: translateX(0);
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;

  /* oculta/exibe painel lateral */
  ${(props) =>
    props.hidden &&
    css`
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transform: translateX(-10px);
    `}
`;

/** Cabeçalho do painel: título + botão de fechar */
Menu.Content.Header = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  padding: 0 2px 8px;
  margin-bottom: 6px;
  border-bottom: 1px solid rgba(216, 224, 235, 0.9);

  > strong {
    display: flex;
    align-items: center;
    gap: 6px;

    color: #17263b;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.4px;
    text-transform: uppercase;

    > svg {
      color: #ff6d3c;
    }
  }

  > button {
    display: flex;
    align-items: center;
    justify-content: center;

    height: 32px;
    width: 32px;
    background: none;
    border: 0;
    border-radius: 9px;
    color: #79869e;
    transition: background 0.2s ease, color 0.2s ease;

    :hover {
      background: rgba(255, 109, 60, 0.12);
      color: #ff6d3c;
    }
  }
`;

Menu.Content.Filter = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  font-size: 12px;
  padding: 0 0 6px;

  > span {
    display: flex;
    align-items: center;
    border: 1px solid rgba(216, 224, 235, 0.9);
    background: rgba(247, 250, 253, 0.9);
    color: #2c405a;
    height: 24px;
    border-radius: 999px;
    padding-left: 9px;
    margin: 2px 0;

    & + span {
      margin-left: 5px;
    }

    > button {
      display: flex;
      align-items: center;
      justify-content: center;

      height: 24px;
      width: 24px;
      color: #79869e;
      margin-left: 3px;
      background: none;
      border: 0;
      border-radius: 999px;
      transition: background 0.2s ease, color 0.2s ease;

      :hover {
        background: rgba(255, 109, 60, 0.14);
        color: #ff6d3c;
      }
    }
  }
`;

Menu.Content.TreeView = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;

  overflow-y: auto;
  overflow-x: hidden;
  padding: 2px;
`;

Menu.Content.File = styled.div`
  margin-top: 20px;
  border-top: 1px solid #0000000d;
  padding: 20px 0;

  > h4 {
    font-size: 16px;
  }

  > ul {
    padding: 15px 0;

    > li {
      padding: 2px 0;

      > a {
        font-size: 14px;
        color: #2c405a;
        transform: color 1s;

        :hover {
          color: ${darken(0.05, '#2c405a')};
        }
      }
    }
  }
`;

export const Content = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;

  /** min-height/min-width 0: permitem que o desenho e a tabela encolham */
  min-height: 0;
  min-width: 0;
  height: 100%;
`;

Content.ToolBar = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 8px;

  min-height: var(--cat-toolbar-h);
  padding: 0 0 6px;
`;

Content.ToolBar.Header = styled.div`
  flex: 1;
  min-width: 0;
  color: #79869e;
  font-size: 12px;

  > div {
    display: flex;
    align-items: center;

    > h5 {
      font-size: 13px;
      display: inline;
      padding-right: 3px;
    }

    > span {
      padding: 3px 0;
      font-size: 13px;
      padding-right: 3px;
    }

    > button {
      display: flex;
      align-items: center;
      justify-content: center;

      margin-left: 5px;
      background-color: #fecaca;
      border-radius: 6px;
      width: 24px;
      height: 24px;
      border: none;
      color: #dc2626;
      transition: 0.3s;

      &:hover {
        background-color: #fca5a5;
        color: #b91c1c;
      }
    }
  }

  > h3 {
    color: #17263b;
    font-size: 15px;
    padding: 2px 0;

    /** título da página não deve quebrar a altura da toolbar */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > a {
    padding: 2px 0;
    transition: color 0.2s ease;

    :hover {
      color: ${darken(0.05, '#888888')};
    }
  }

  @media (max-width: 1440px), (max-height: 900px) {
    > h3 {
      font-size: 14px;
    }
  }
`;

Content.ToolBar.DrawControl = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  padding: 2px;
  background: #fff;
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 12px;
  box-shadow: 0 6px 16px rgba(23, 38, 59, 0.05);

  > button,
  span {
    display: flex;
    align-items: center;
    justify-content: center;

    /** 34px mantém o alvo de toque confortável em tablet */
    height: 34px;
    width: 34px;
    border-radius: 9px;
    background: none;
    border: 0;
    color: #2c405a;
    transition: background 0.2s ease, color 0.2s ease;

    + button {
      margin-left: 2px;
    }

    + span {
      width: auto;
      min-width: 34px;
      margin-left: 4px;
      padding: 0 8px;
      font-size: 13px;
      font-weight: 700;
      white-space: nowrap;
    }

    :hover {
      background: rgba(255, 109, 60, 0.12);
      color: #ff6d3c;
    }

    &:disabled {
      opacity: 0.55;
      cursor: default;
    }
  }

  /** separação entre navegação de páginas e ferramentas da imagem */
  button:nth-of-type(2) {
    margin-right: 4px;
  }
`;

export const BtnFilter = styled.button`
  padding: 0 8px;
  height: 40px;
  margin: auto;
  background-color: #2c405a;
  color: #fff;
  border-radius: 0 5px 5px 0;
  border: none;
`;

export { Menu };
